import { motion } from "motion/react";
import { Shield } from "lucide-react";
import { Link } from "react-router";
import { SEO } from "./SEO";

export function PrivacyPolicy() {
    return (
        <div className="max-w-4xl mx-auto px-6 py-12">
            <SEO
                title="Privacy Policy | Solace SMART Solutions"
                description="Our commitment to protecting your privacy. Read our policy on how we handle and protect your personal data."
            />
            <Link to="/" className="text-[#E9A319] hover:underline mb-8 inline-block text-sm font-semibold">&larr; Back to Home</Link>
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
                <div className="flex items-center gap-4 mb-8 pb-8 border-b border-gray-100">
                    <div className="w-14 h-14 bg-blue-50 text-[#1a2d50] rounded-xl flex items-center justify-center shrink-0">
                        <Shield className="w-7 h-7" />
                    </div>
                    <div>
                        <h1 className="text-3xl md:text-4xl text-[#1a2d50]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800 }}>Privacy Policy</h1>
                        <p className="text-muted-foreground mt-1">Last Updated: October 2023</p>
                    </div>
                </div>

                <div className="space-y-8 text-gray-700" style={{ lineHeight: 1.8 }}>
                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>1. Introduction</h2>
                        <p>Welcome to Solace SMART Solutions ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
                    </section>

                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>2. Data We Collect</h2>
                        <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
                            <li><strong>Contact Data:</strong> includes billing address, delivery address, email address and telephone numbers.</li>
                            <li><strong>Technical Data:</strong> includes internet protocol (IP) address, browser type and version, time zone setting and location.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>3. How We Use Your Data</h2>
                        <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
                            <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
                            <li>Where we need to comply with a legal or regulatory obligation.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>4. Contact Us</h2>
                        <p>If you have any questions about this privacy policy or our privacy practices, please contact us at:</p>
                        <p className="mt-2 font-medium">Email: Connect@Solacesmart.com</p>
                        <p className="font-medium">Phone: +91 88008-78095</p>
                    </section>
                </div>
            </div>
        </div>
    );
}
